import React from 'react'
export default function FeaturedImage ({ source_url, slug }) {
  return (
    <img
      src={source_url}
      alt={`Featured - ${slug}`}
      title={slug}
      className='w-full  h-full object-cover absolute z-0'
    />
  )
}
